<template>
  <sign-up-carousel-wrapper>
    <template #img>
      <img
        height="392"
        src="@/assets/img/signup-carousel-fifth@2x.png"
        alt=""
      />
    </template>
    <template #title>{{ $t("Respondemos todas tus preguntas") }}</template>
    <template #caption>
      {{ $t("SignUp_Carousel_Caption5") }}
    </template>
  </sign-up-carousel-wrapper>
</template>

<script>
import SignUpCarouselWrapper from "./SignUpCarouselWrapper.vue";

export default {
  components: { SignUpCarouselWrapper },
};
</script>

<style></style>
